import React, { useEffect } from "react";
import "../style.css";
import { Text, View, Flex } from "@adobe/react-spectrum";
import { NoChatIcon } from "../../common/Icons";
import storeRTK from "../../../store/storeRTK";
import { setSelectedTab } from "../../../actions/common";
import { useSelector } from "react-redux";
import { setHistoryfilterChatCount } from "../../../actions/chat";
import { RootState } from "../../../store/storeConfig";

const ChatDefaultPage: React.FC = () => {
  const history = useSelector((state: RootState) => state.history);
  const redirectToChatHistory = () => {
    storeRTK.dispatch(setSelectedTab("History"));
  };

  useEffect(() => {
    storeRTK.dispatch(setHistoryfilterChatCount(history?.chat?.length));
  }, []);

  return (
    <View UNSAFE_className="no-chat-wrapper">
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        direction={"column"}
        height={"100%"}
      >
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          UNSAFE_className="no-chat-icon"
        >
          <NoChatIcon />
        </Flex>
        <Flex justifyContent={"center"} UNSAFE_className="no-chat-heading">
          <Text>No active chat</Text>
        </Flex>
        <Flex
          justifyContent={"center"}
          UNSAFE_className="no-chat-description"
          marginTop={8}
        >
          <Text>There are no active chats at this time.</Text>
        </Flex>
        <Flex justifyContent={"center"} UNSAFE_className="no-chat-description">
          <Text>
            You can view the past chats from{" "}
            <span className="hyperlink-chat" onClick={redirectToChatHistory}>
              history tab
            </span>
          </Text>
        </Flex>
      </Flex>
    </View>
  );
};

export default ChatDefaultPage;
